import classNames from "classnames";
import scss from "@/styles/pages/free-resources/slider.module.scss";

export const freeResourcesSliderWrapper = classNames([
    "w-full",
    "h-auto",
    "bg-gray-200",
    // "mt-10",
    "pt-10",
    "pb-5"
])

export const rightArrow = [
    /* laptop */
    "laptop:left-[60%]",
    "laptop:top-[35%]",
    /* Mobile LG */
    "mobile-lg:left-2/3",
    "mobile-lg:top-1/3",
    "mobile-lg:-translate-x-2",
    /* All */
    "absolute",
    "top-1/3",
    "right-2",
    "transform -translate-y-1/2",
    "z-40",
    "focus:outline-none",
    "flex",
    "items-center",
    "justify-center",
    "w-[40px]",
    "h-[40px]",
];

export const leftArrow = [
    /* laptop */
    "laptop:left-[calc(40%_+_8px)]",
    "laptop:top-[35%]",
    /* Mobile LG */
    "mobile-lg:left-1/3",
    "mobile-lg:-translate-x-10",
    /* All */
    "left-2",
    "top-1/3",
    "absolute",
    "transform -translate-y-1/2",
    "z-40",
    "focus:outline-none",
    "flex",
    "items-center",
    "justify-center",
    "w-[40px]",
    "h-[40px]",
];
